<template>
    <flex-element
        v-plaintext
        :element-type="elementType"
        class="f-break-words"
        tag="label"
        :for="renderLabelFor"
    >
        <span
            v-text-select="singleLineTextNew"
            :contenteditable="isContentEditable"
            @input="setChangedData(true)"
            @blur="onInput"
        />
    </flex-element>
</template>

<script>
import baseAtom from '@/mixins/base-atom/base-atom-smart';
import { ALabel } from '@/data/data-models';

const PLACEHOLDER_TEXT = '[Text here]';

export default {
    name: 'a-label',
    mixins: [baseAtom],

    props: {
        displayName: {
            type: String,
            default: 'Single Line Text',
        },

        singleLineText: {
            type: String,
            default: '',
        },

        labelFor: {
            type: String,
            default: '',
        },

        templateId: {
            type: String,
            default: '{74E93252-C92B-4790-A388-33CE4502DB59}',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
            singleLineTextNew: '',
            labelForNew: '',
        };
    },

    computed: {
        renderTextPreview() {
            if (this.singleLineTextNew === PLACEHOLDER_TEXT) {
                return '';
            }
            return this.singleLineTextNew;
        },

        renderLabelFor() {
            return this.labelForNew || '';
        },

        updatedElement() {
            return new ALabel({
                ...this.updatedBaseElement,
                singleLineText: this.singleLineTextNew === PLACEHOLDER_TEXT ? '' : this.singleLineTextNew,
                labelFor: this.labelForNew,
            });
        },
    },

    methods: {
        setFieldValues() {
            this.singleLineTextNew = this.singleLineText
                || (this.$slots.default ? this.$slots.default[0].text.trim() : PLACEHOLDER_TEXT);
            this.labelForNew = this.labelFor;
        },

        onInput(e) {
            this.singleLineTextNew = e.target.innerText;
        },
    },
};
</script>
